import {Component} from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgxJsonLdModule } from '@ngx-lite/json-ld';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    standalone: true,
    imports: [NgxJsonLdModule, RouterLink]
})
export class AboutComponent {
}
